export const POST_REPORTS = "POST_REPORTS";
export const POST_REPORTS_SUCCESS = "POST_REPORTS_SUCCESS";
export const POST_REPORTS_ERROR = "POST_REPORTS_ERROR";
export const POST_REPORTS_CLEAR_DATA = "POST_REPORTS_CLEAR_DATA";

export const EXECUTE_REPORT = "EXECUTE_REPORT";
export const EXECUTE_REPORT_SUCCESS = "EXECUTE_REPORT_SUCCESS";
export const EXECUTE_REPORT_ERROR = "EXECUTE_REPORT_ERROR";
export const EXECUTE_REPORT_CLEAR_DATA = "EXECUTE_REPORT_CLEAR_DATA";

export const REPORT_EXPORT_EXCEL = "REPORT_EXPORT_EXCEL";
export const REPORT_EXPORT_EXCEL_SUCCESS = "REPORT_EXPORT_EXCEL_SUCCESS";
export const REPORT_EXPORT_EXCEL_ERROR = "REPORT_EXPORT_EXCEL_ERROR";
export const REPORT_EXPORT_EXCEL_CLEAR_DATA = "REPORT_EXPORT_EXCEL_CLEAR_DATA";
